import styled from "styled-components";

export const Container = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  font-weight: 700;
  vertical-align: middle;
  white-space: nowrap;

  &.sim {
    background: var(--atencao-20);
    color: #573A00;
  }

  &.nao {
    background: transparent;
    border-color: var(--cinza-40);
    color: var(--cinza-80);
  }

  &.cj {
    background: var(--principal-10);
    color: #2E5D38;
  }

  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;
